module.exports = __webpack_public_path__ + "img/quote-PCB@ico.f418e78c.png";